module.exports = {
	baseUrl: '/mapi' // 本地测试可以这么写，所有的请求代理，在vue.config.js 里面写上服务器地址，这里面只配置了本地serve命令的，build还继续使用nginx代理
	// baseUrl: '/api-web/mapi' // 发布用
	// baseUrl: '/mapi', // nginx转换
	// imagesUrl: '/imagesUrl' // 图片跨域
	
	
	// baseUrl: '/zhongljBack_maven/mapi',   /* 测试打开 */
}
